module.exports = __webpack_public_path__ + "static/6-3bba9ce8285d3632a27386f164ed1d6e.jpg";